import React from 'react'
import styled from '@emotion/styled'
import { Filter } from 'lucide-react'
import { PRIMARY_PAGE_TEXT_COLOR_VAR } from '../../context/CustomizationContextProvider'
import { getTypographyRoleStyle } from '../../style/typography'
import { scaledFontSize } from '../../style/scrollingLayout'

const FilterButton = styled.button({
    background: 'transparent',
    border: 'none',
    padding: 0,
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    gap: 4,
    ...getTypographyRoleStyle('navText', {
        fontWeight: 500,
    }),
    fontSize: scaledFontSize(12),
    color: `var(${PRIMARY_PAGE_TEXT_COLOR_VAR})`,
    transition: 'opacity 0.15s ease',
    opacity: 0.7,
    '&:hover': {
        opacity: 1,
    },
    '&:focus': {
        outline: 'none',
    },
})

// Emotion styled components automatically forward refs, so we can use forwardRef directly
export const ProductFilterButton = React.forwardRef<
    HTMLButtonElement,
    React.ButtonHTMLAttributes<HTMLButtonElement>
>(({ ...props }, ref) => {
    return (
        <FilterButton ref={ref} type="button" {...props}>
            <Filter size={14} />
            Filter
        </FilterButton>
    )
})

ProductFilterButton.displayName = 'ProductFilterButton'
